<script>
	import ScWallet from '$lib/home/scwallet/SCWallet.svelte';
</script>

<div class="flex flex-col sm:justify-center  w-full rounded-2xl">
	<ScWallet />
</div>
